//
import Model from '@/models/Model'

/**
 * This class describes an acc account conciliation.
 *
 * @class      AccAccountConciliation (name)
 */
export default class AccAccountConciliation extends Model {

    //
    details_account_conciliation = []

    /**
     * { item_description }
     */
    fetchMultiSuggest = () => {
        this.details_account_conciliation_fetching = true
        return this.request({
            type: 'get',
            url: this.fullURL(),
            params: {
                acc_account_id: this.acc_account_id,
            },
        }).then(this.setMultiSuggest)
    }

    /**
     * { lambda_description }
     *
     * @param      {<type>}  item    The item
     * @param      {<type>}  id      The identifier
     */
    mapMultiSuggestSubItem = multi_suggest_id => item => ({
        ...item,
        multi_suggest_id,
    })

    /**
     * { lambda_description }
     *
     * @param      {<type>}  item    The item
     * @param      {<type>}  id      The identifier
     */
    mapMultiSuggest = item => ({
        ...item,
        credit_account: item.credit > 0 ? item.acc_account.comment : '-',
        debit_account: item.debit > 0 ? item.acc_account.comment : '-',
    })

    /**
     * { lambda_description }
     *
     * @param      {<type>}  item    The item
     * @param      {<type>}  id      The identifier
     */
    reduceMultiSuggest = (items, item, index) => ([
        ...items,
        ...item.debits.map(this.mapMultiSuggestSubItem(index)),
        ...item.credits.map(this.mapMultiSuggestSubItem(index)),
    ])

    /**
     * { function_description }
     *
     * @return     {string}  { description_of_the_return_value }
     */
    resource() {
        return 'acc_account_conciliation'
    }

    /**
     * Sets the multi suggest.
     *
     * @param      {<type>}  res     The new value
     */
    setMultiSuggest = (res) => {
        this.details_account_conciliation = res.data.reduce(this.reduceMultiSuggest, []).map(this.mapMultiSuggest)
    }
}
